import { SWITCH_PAGE } from '../constants';

export const switchPage = page => ({type: SWITCH_PAGE, payload: page});